export const POST_LOGIN_REDIRECT_KEY = 'io-marketplace/post-login-redirect';

